export default __webpack_public_path__ + "static/media/brain.4af7abd7.svg";